import { MarkdownViewer } from '@stoplight/elements-core/components/MarkdownViewer';
import { HStack, Text } from '@stoplight/mosaic';
import * as React from 'react';

/**
 * Renders custom extensions like [x-rate-limits]
 */
export const renderExtensionRenderer = (props: any) => {
  const { vendorExtensions } = props;
  function formatDuration(seconds: string) {
    switch (seconds) {
      case '1':
        return 'per second';
      case '60':
        return 'per minute';
      case '3600':
        return 'per hour';
      default:
        const secondVal = parseInt(seconds);
        if (secondVal % 3600 == 0) return `per ${secondVal / 3600} hours`;
        else if (secondVal % 60 == 0) return `per ${secondVal / 60} minutes`;
        else return `per ${seconds} seconds`;
    }
  }

  if ('x-rate-limits' in vendorExtensions) {
    const { 'x-rate-limits': rateLimits = [] } = vendorExtensions;
    const rateLimitMarkdown = `<!-- theme: info -->\n\n> #### Rate Limit\n>\n>${rateLimits
      .map((r: any, _: any) => `${r.limit} requests ${formatDuration(r.durationSeconds)}`)
      .join(', ')}`;
    return <MarkdownViewer markdown={rateLimitMarkdown} />;
  }

  if ('x-unit' in vendorExtensions) {
    const { 'x-unit': unit } = vendorExtensions;
    return (
      <HStack spacing={2} alignItems="baseline" color="muted">
        <Text>Unit:</Text>
        <Text>{unit}</Text>
      </HStack>
    );
  }
  return null;
};
